import React from "react";

import Card from "./Card";
import { useUtilityStates } from "../useStates";
import Title from "../../LoanTermDeviation/Title";
import { SliderContainerType } from "../SliderContainer";

export default function ExisitingOffer(props: SliderContainerType) {
  const { close, pageName } = props;
  const { existingOffers = [] } = useUtilityStates((state) => state);

  return (
    <div className="p-10">
      <Title
        close={close}
        title="Existing Offers"
      />
      <div className="mt-6">
        {existingOffers?.map((offer, index: number) => (
          <div
            key={index}
            className="mb-4 last:mb-0"
          >
            <Card
              offer={offer}
              pageName={pageName}
              index={index}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
